/**
 * @generated SignedSource<<71cb3964a52be479736778116901f323>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetTodoSummaryUpdateInput = {
  setTeamIds?: ReadonlyArray<string> | null;
};
export type WSTodoSummaryMutation$variables = {
  storecastId: string;
  update: WidgetTodoSummaryUpdateInput;
  widgetId: string;
};
export type WSTodoSummaryMutation$data = {
  readonly dashboard: {
    readonly updateWidgetTodoSummary: {
      readonly assignedTeams: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly id: string;
    };
  };
};
export type WSTodoSummaryMutation = {
  response: WSTodoSummaryMutation$data;
  variables: WSTodoSummaryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "update"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "widgetId"
          },
          {
            "kind": "Variable",
            "name": "update",
            "variableName": "update"
          }
        ],
        "concreteType": "WidgetTodoSummary",
        "kind": "LinkedField",
        "name": "updateWidgetTodoSummary",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "assignedTeams",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSTodoSummaryMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSTodoSummaryMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "f768bd1844474b610a152f3c4a7875d9",
    "id": null,
    "metadata": {},
    "name": "WSTodoSummaryMutation",
    "operationKind": "mutation",
    "text": "mutation WSTodoSummaryMutation(\n  $storecastId: ID!\n  $widgetId: ID!\n  $update: WidgetTodoSummaryUpdateInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetTodoSummary(id: $widgetId, update: $update) {\n      id\n      assignedTeams {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d6f4f1558970adc774cb78166054410";

export default node;
